import React from "react";

import BlockList from "~/blocks/BlockList";

const NewsArticleBlockList = ({ data, urlPermutations }) => {
    const {
        wpNewsArticle: { blocks },
    } = data;

    return <BlockList {...{ blocks, urlPermutations }} isKCArticle />;
};

export default NewsArticleBlockList;
